import React from 'react'
import PropTypes from 'prop-types'
import { useAppContext } from '../../../redux/slices/appContext'
import { DEFAULT_LAYOUT, LAYOUTS } from './supplementalLayouts'
import { sourceHasRenderableTaskItems } from './supplementalLayouts/badge/sourceDisplayUtils'
import { useStatusReportItemSupplementalContentContext } from './StatusReportItemSupplementalContentContext'

function renderSource (source, { isAdvisor }) {
  if (!sourceHasRenderableTaskItems(source)) return null

  const displayConfig = source.displayConfig ?? {}
  const layoutCode = displayConfig.layout ?? DEFAULT_LAYOUT
  const Layout = LAYOUTS[layoutCode] ?? LAYOUTS[DEFAULT_LAYOUT]
  return (
    <Layout
      key={source.supplementalSourceId ?? layoutCode}
      data={source.data}
      displayConfig={displayConfig}
      isAdvisor={isAdvisor}
    />
  )
}

function renderSourceWithHeader (source, ctx) {
  const node = renderSource(source, ctx)
  if (!node) return null
  const header = source.displayConfig?.header
  return (
    <div key={source.supplementalSourceId ?? 'src'}>
      {header && (
        <p className='font-weight-light font-size-xs m-0'>{header}</p>
      )}
      {node}
    </div>
  )
}

function StatusReportItemSupplementalContent ({ item }) {
  const { getItemSupplementalData, isLoading } = useStatusReportItemSupplementalContentContext()
  const { isAdvisor } = useAppContext()

  const itemData = getItemSupplementalData(item?.statusReportItemId)
  if (!itemData?.sources?.length || isLoading) return null

  const withData = itemData.sources.filter(s => s.data !== undefined && s.data !== null)
  if (!withData.length) return null

  const nodes = withData.map(s => renderSourceWithHeader(s, { isAdvisor })).filter(Boolean)
  if (!nodes.length) return null

  return <div className='flex flex-col gap-3'>{nodes}</div>
}

StatusReportItemSupplementalContent.propTypes = {
  item: PropTypes.shape({
    statusReportItemId: PropTypes.number.isRequired
  }).isRequired
}

export default StatusReportItemSupplementalContent
